"use client";

import { Container, Row, Col } from "react-bootstrap";
import Image from "next/image";

import "./BeforeYouCommitSection.scss";

const BeforeYouCommitSection = ({ BeforeYouCommit }) => {
  if (!BeforeYouCommit) return null;

  const { title, description, implementation } = BeforeYouCommit;

  const titleParts = title.split('"');

  return (
    <section className="before-you-commit-section">
      <Container>
        <Row className="align-items-center justify-content-between">
          {/* LEFT CONTENT */}
          <Col xxl={5} xl={5} lg={5} md={12}>
            <div className="before-you-commit-content">
              <h2 className="before-you-commit-title">
                {titleParts[0]}
                <span className="highlight-font">
                  {titleParts[1]}
                </span>
                {titleParts[2]}
              </h2>

              <p className="before-you-commit-description">
                {description}
              </p>
            </div>
          </Col>

          {/* RIGHT CARDS */}
          <Col xxl={7} xl={7} lg={7} md={12}>
            <div className="before-you-commit-cards">
              <Row>
                {implementation.map((item, index) => (
                  <Col
                    key={index}
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    className="before-you-commit-card-column"
                  >
                    <div className="before-you-commit-card">
                      <div className="before-you-commit-icon">
                        <Image
                          src={item.icon}
                          alt={item.title}
                          width={48}
                          height={48}
                        />
                      </div>

                      <h3 className="before-you-commit-card-title">
                        {item.title}
                      </h3>

                      <p className="before-you-commit-card-description">
                        {item.description}
                      </p>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BeforeYouCommitSection;